// const TICKER_TAPE_MOTION = 200;

/**
 * Content Slider class to object and add listeners to 
 * multiple content sliders
 */
export default class TickerTape {

    constructor($element) {
        this.el = $element;

    }

}